export function selectMany(array, fn) {
    return array.map(fn).reduce(function (x, y) { return x.concat(y); }, []);
}
export const requiredCustom = (message = 'ra.validation.required') => 
    Object.assign(
        (value, allValues, props) => value ? undefined : props.translate(message),
        { isRequired: true }
    );
